import {Mapper} from '@s-ui/domain'

const TAGCLOUD_CITY = 'City'
const TAGCLOUD_MAKE = 'Make'
const TAGCLOUD_MAKEMODELSCLASSICS = 'MakeModelsClassics'
const TAGCLOUD_MAKES = 'makes'
const TAGCLOUD_MODEL = 'Model'
const TAGCLOUD_MODELS = 'models'
const TAGCLOUD_PROVINCE = 'Province'
const TAGCLOUD_RELEVANT_LABELS = 'RelevantLabels'
const TAGCLOUD_STOCK = 'stock'
const TAGCLOUD_VERSION = 'Version'
const TAGCLOUD_MAKE_MODEL_CAMPERS = 'MakeModelsCampers'
const TAGCLOUD_MAKE_MODEL_CARAVANAS = 'MakeModelsCaravanas'
const TAGCLOUD_MAKE_MODEL_AUTOCARAVANAS = 'MakeModelsAutocaravanas'
const TAGCLOUD_DEALERS_PROVINCES = 'dealersProvinces'
const TAGCLOUD_DEALERS_MAKES = 'dealersMakes'
const TAGCLOUD_DEALERS_CITIES = 'dealersCities'
const TAGCLOUD_NEWS = 'Noticias'
const TAGCLOUD_CARS_CHEAP = 'Coches-baratos'
const TAGCLOUD_CARS_SECOND_HAND = 'Coches-segunda-mano'
const TAGCLOUD_KM0 = 'Km0'
const TAGCLOUD_CAMPER = 'Camper'
const TAGCLOUD_REMOLQUES = 'Remolques'
const TAGCLOUD_CARAVANAS = 'Caravanas'
const TAGCLOUD_TRACTORES = 'Tractores'
const TAGCLOUD_MAKE_MODELS_AUTOCARAVANAS = 'MakeModelsAutocaravanas'
const TAGCLOUD_INDUSTRIALES = 'Industriales'
const TAGCLOUD_COMMON_SEARCHES_FURGONETAS = 'CommonSearchesFurgonetas'
const TAGCLOUD_FINANCED = 'financiados'

const tagCloudGroupNames = [
  TAGCLOUD_CITY,
  TAGCLOUD_MAKE,
  TAGCLOUD_MAKEMODELSCLASSICS,
  TAGCLOUD_MAKES,
  TAGCLOUD_MODEL,
  TAGCLOUD_MODELS,
  TAGCLOUD_PROVINCE,
  TAGCLOUD_STOCK,
  TAGCLOUD_VERSION,
  TAGCLOUD_MAKE_MODEL_CAMPERS,
  TAGCLOUD_MAKE_MODEL_CARAVANAS,
  TAGCLOUD_MAKE_MODEL_AUTOCARAVANAS,
  TAGCLOUD_DEALERS_PROVINCES,
  TAGCLOUD_DEALERS_MAKES,
  TAGCLOUD_DEALERS_CITIES
]

const tagCloudGroupNamesWithAttributes = [
  TAGCLOUD_CITY,
  TAGCLOUD_PROVINCE,
  TAGCLOUD_MAKE,
  TAGCLOUD_MODEL,
  TAGCLOUD_VERSION
]

export class FromTagCloudJsonResponseToTagCloudSeoValueObjectSeoMapper extends Mapper {
  constructor({config, tagcloudSeoValueObjectFactory, tagcloudListValueObjectFactory}) {
    super()
    this._config = config
    this._tagcloudSeoValueObjectFactory = tagcloudSeoValueObjectFactory
    this._tagcloudListValueObjectFactory = tagcloudListValueObjectFactory

    this._sectionIdMapping = config.get('page').SECTION_ID_MAPPING
    this._searchSectionIdMapping = config.get('SEARCH_SECTION_ID_MAPPING')
  }

  _buildTagCloudName({normalizedSectionId, normalizedSearchSectionId}) {
    return name => {
      if (tagCloudGroupNames.includes(name))
        return `TAGCLOUD_${normalizedSearchSectionId}_${normalizedSectionId}_${name}`.toUpperCase()

      if (name === 'MostSearched') return `COMMON_MOSTSEARCHED`

      return null
    }
  }

  _getAttributes({name, normalizedSectionId, normalizedSearchSectionId}) {
    const hasAttribute = tagCloudGroupNamesWithAttributes.includes(name)

    if (!hasAttribute) return {}

    const title =
      name === TAGCLOUD_PROVINCE
        ? `TAGCLOUD.TITLE_ATTR_${normalizedSearchSectionId}_PROVINCE`.toUpperCase()
        : `TAGCLOUD.TITLE_ATTR_${normalizedSearchSectionId}`.toUpperCase()
    return {title}
  }

  _excludeGroupsByPage = ({pageName, tagclouds}) => {
    const EXCLUSION_GROUPS = {
      'news-detail': TAGCLOUD_RELEVANT_LABELS,
      'news-comments': TAGCLOUD_RELEVANT_LABELS,
      'vehicle-configurator': [
        TAGCLOUD_CITY,
        TAGCLOUD_PROVINCE,
        TAGCLOUD_MAKE_MODEL_CAMPERS,
        TAGCLOUD_MAKEMODELSCLASSICS,
        TAGCLOUD_MAKE_MODEL_CARAVANAS,
        TAGCLOUD_NEWS,
        TAGCLOUD_CARS_CHEAP,
        TAGCLOUD_CARS_SECOND_HAND,
        TAGCLOUD_KM0,
        TAGCLOUD_CAMPER,
        TAGCLOUD_REMOLQUES,
        TAGCLOUD_CARAVANAS,
        TAGCLOUD_TRACTORES,
        TAGCLOUD_MAKE_MODELS_AUTOCARAVANAS,
        TAGCLOUD_INDUSTRIALES,
        TAGCLOUD_COMMON_SEARCHES_FURGONETAS,
        TAGCLOUD_FINANCED
      ]
    }

    const exclusions = EXCLUSION_GROUPS[pageName]
    if (!exclusions) return tagclouds

    const exclusionsArray = Array.isArray(exclusions) ? exclusions : [exclusions]
    return tagclouds.filter(({name}) => !exclusionsArray.includes(name))
  }

  map = ({sectionId, searchSectionId, tagclouds, pageName, hasAttributes}) => {
    const normalizedSectionId = this._sectionIdMapping[sectionId]

    const normalizedSearchSectionId = this._searchSectionIdMapping[searchSectionId]

    const generateTitleLiteral = this._buildTagCloudName({
      normalizedSectionId,
      normalizedSearchSectionId
    })

    const tagcloudsList = this._excludeGroupsByPage({
      pageName,
      tagclouds
    }).map(({name, tags}) => {
      const attributes = hasAttributes
        ? this._getAttributes({
            name,
            normalizedSectionId,
            normalizedSearchSectionId
          })
        : null

      return this._tagcloudSeoValueObjectFactory({
        title: generateTitleLiteral(name),
        ...(attributes && {attributes}),
        tags,
        pageName
      })
    })

    return this._tagcloudListValueObjectFactory({tagclouds: tagcloudsList})
  }
}
